// extracted by mini-css-extract-plugin
export var active = "_vg-1";
export var circle = "_vg-0";
export var completed = "_vg-2";
export var connector = "_vg-4";
export var connectorCompleted = "_vg-7";
export var connectorSpacer = "_vg-5";
export var iconStrokeOverride = "_vg-8";
export var labelContainer = "_vg-6";
export var pending = "_vg-3";